import { WheelDesign } from "./WheelDesign";

export default WheelDesign;